module.exports = __webpack_public_path__ + "img/1536261571.4f8f6ca5.jpg";